(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-rich-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seo-read-more')) {
  customElements.define('seo-read-more', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-seo-rte]');
      this.toggle = this.querySelector('[data-seo-toggle]');
      this.moreEl = this.querySelector('[data-seo-label-more]');
      this.lessEl = this.querySelector('[data-seo-label-less]');
      if (!this.content || !this.toggle) return;

      this.userToggled = false;
      this.onResize = this.evaluate.bind(this);
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.onResize);

      this.evaluate();
      if (document.readyState !== 'complete') {
        window.addEventListener('load', this.onResize, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    getMax() {
      var mobile = window.matchMedia('(max-width: 767px)').matches;
      var value = getComputedStyle(this).getPropertyValue(mobile ? '--seo-max-h-m' : '--seo-max-h-d');
      return parseFloat(value) || 0;
    }

    overflows() {
      var max = this.getMax();
      return max > 0 && this.content.scrollHeight > max + 2;
    }

    evaluate() {
      if (this.userToggled) return;
      if (this.overflows()) {
        this.classList.add('is-collapsed');
        this.toggle.hidden = false;
        this.setExpanded(false);
      } else {
        this.classList.remove('is-collapsed');
        this.toggle.hidden = true;
      }
    }

    onClick() {
      this.userToggled = true;
      var collapsed = this.classList.toggle('is-collapsed');
      this.setExpanded(!collapsed);
    }

    setExpanded(expanded) {
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (this.moreEl) this.moreEl.hidden = expanded;
      if (this.lessEl) this.lessEl.hidden = !expanded;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
